import { injectStyles } from "./shadowPortal"
// Shared UI components that the viewer renders into the shadow DOM but which live OUTSIDE the
// customWebviewer tree, so the glob below (rooted at customWebviewer/) can't reach them. These
// stay as explicit imports — dropping them silently unstyles every button + the confirm modals
// inside the shadow root.
import buttonPrimaryStyles from "components/ui/buttons/ButtonPrimary/ButtonPrimary.module.scss?inline"
import buttonSecondaryStyles from "components/ui/buttons/ButtonSecondary/ButtonSecondary.module.scss?inline"
import buttonOutlineStyles from "components/ui/buttons/ButtonOutline/ButtonOutline.module.scss?inline"
import buttonDangerStyles from "components/ui/buttons/ButtonDanger/ButtonDanger.module.scss?inline"
import buttonOptionsStyles from "components/ui/buttons/ButtonOptions/ButtonOptions.module.scss?inline"
import confirmModalStyles from "components/ui/modals/ConfirmModal/ConfirmModal.module.scss?inline"
// #1346 — the create-custom-model-number dialog (#1345's) is opened from the picker's Custom tab and
// portals into this shadow root, so its two stylesheets have to come with it. They live under
// components/pages/, well outside the glob's reach.
import customModelNumberModalStyles from "components/pages/PageAllFiles/layout/FileInfo/layout/CustomModelNumbers/CustomModelNumberModal.module.scss?inline"
import selectBaseModelNumberModalStyles from "components/pages/PageAllFiles/layout/FileInfo/layout/CustomModelNumbers/SelectBaseModelNumberModal.module.scss?inline"

// Every `*.module.scss` under customWebviewer/ is auto-collected and injected, so a new sidebar
// component no longer needs a manual import + inject step (previously ~46 hand-listed lines in
// the orchestrator — see AGENTS.md "Shadow DOM style injection"). Extra module.scss files that
// aren't actually rendered into the shadow DOM are harmless: CSS-module class names are hashed,
// so unused rules never collide.
const localStyleModules = import.meta.glob<string>("../**/*.module.scss", {
	query: "?inline",
	import: "default",
	eager: true,
})

const externalStyles = [
	buttonPrimaryStyles,
	buttonSecondaryStyles,
	buttonOutlineStyles,
	buttonDangerStyles,
	buttonOptionsStyles,
	confirmModalStyles,
	customModelNumberModalStyles,
	selectBaseModelNumberModalStyles,
]

// Inject every shadow-scoped stylesheet into the Apryse web component's shadow root. Called once
// during viewer init, right after the shadow root becomes available.
export const injectAllShadowStyles = (shadowRoot: ShadowRoot) => {
	for (const css of Object.values(localStyleModules)) {
		injectStyles(shadowRoot, css)
	}
	for (const css of externalStyles) {
		injectStyles(shadowRoot, css)
	}
}
